"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1239],{

/***/ 81608:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo-transparent.13d3aedb.png","height":120,"width":413,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEWZm5GYnJGZx1+enp6ZqpmWwGGZnJGfyGnlpE5XAAAACHRSTlNje5sKB3OMuk0f7GwAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAaSURBVHicY2BlYmdiZmFhZmBkZGNkYGBgAAAB5QAoNadi5AAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 21239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ home_Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/static/images/icon/logo-transparent.png
var logo_transparent = __webpack_require__(81608);
// EXTERNAL MODULE: ./src/utils/customer.js
var customer = __webpack_require__(66701);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-burger-menu/lib/BurgerMenu.js
var BurgerMenu = __webpack_require__(73190);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./src/components/home/PlacesSearch/index.jsx + 2 modules
var PlacesSearch = __webpack_require__(69174);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(26626);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/redux/actions/search.js
var search = __webpack_require__(44743);
// EXTERNAL MODULE: ./node_modules/algoliasearch/dist/algoliasearch-lite.umd.js
var algoliasearch_lite_umd = __webpack_require__(48434);
var algoliasearch_lite_umd_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_lite_umd);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/widgets/InstantSearch.js + 5 modules
var InstantSearch = __webpack_require__(56843);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/widgets/Configure.js + 1 modules
var Configure = __webpack_require__(34859);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/widgets/Index.js
var Index = __webpack_require__(26808);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-autosuggest/dist/index.js
var dist = __webpack_require__(58808);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var react_hot_toast_dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-dom/dist/es/widgets/Highlight.js + 3 modules
var Highlight = __webpack_require__(28568);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectAutoComplete.js
var connectAutoComplete = __webpack_require__(47849);
;// CONCATENATED MODULE: ./src/components/home/Header/AutoComplete.jsx















var categorySelection, categorySelectionInput = null;
var AutoComplete = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(AutoComplete, Component);
    var _super = (0,_create_super/* default */.Z)(AutoComplete);
    function AutoComplete() {
        (0,_class_call_check/* default */.Z)(this, AutoComplete);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "state", {
            value: _this.props.currentRefinement
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onChange", function(event, param) {
            var newValue = param.newValue;
            _this.setState({
                value: newValue
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onSuggestionsFetchRequested", function(param) {
            var value = param.value;
            _this.props.refine(value);
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onSuggestionsClearRequested", function() {
            _this.props.refine();
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onKeyDown", function(event) {
            var keyCode = event.keyCode;
            if (keyCode === 13 && !_this.suggestionSelected) {
                var totalHits = 0;
                var searchterm = _this.state.value.replace("/", "");
                if (_this.props.hits.length > 0) {
                    _this.props.hits.map(function(x) {
                        totalHits = totalHits + x.hits.length;
                    });
                }
                if (totalHits > 0) {
                    _this.props.setSearchValue({
                        query: searchterm
                    });
                    router_default().push("/search/[searchterm]", "/search/".concat(searchterm)).then(function() {
                        if (window) {
                            window.scrollTo(0, 0);
                        }
                    });
                    categorySelectionInput.blur();
                } else {
                    react_hot_toast_dist/* default.error */.ZP.error("Search will yield no results!");
                }
            }
            _this.suggestionSelected = false;
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(AutoComplete, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                categorySelection = document.getElementById("category-selection");
                categorySelectionInput = categorySelection.querySelectorAll("input")[0];
            }
        },
        {
            key: "getSuggestionValue",
            value: function getSuggestionValue(hit) {
                return hit.name;
            }
        },
        {
            key: "renderSuggestion",
            value: function renderSuggestion(hit) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "custom-highlight",
                    children: [
                        hit.imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: hit.imageUrl,
                            alt: hit.name
                        }),
                        hit.CategoryImageURL && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: hit.CategoryImageURL,
                            alt: hit.name
                        }),
                        !hit.imageUrl || hit.CategoryImageURL && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fas fa-2x fa-car-battery"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                            attribute: "name",
                            hit: hit,
                            tagName: "mark"
                        }),
                        hit.CatImageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                            className: "mr-1 ml-1",
                            children: "by"
                        }),
                        hit.CatImageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "smaller-thumb",
                            src: hit.CatImageUrl,
                            alt: hit.name
                        })
                    ]
                });
            }
        },
        {
            key: "renderSectionTitle",
            value: function renderSectionTitle(section) {
                if (section.hits <= 0) {
                    return "";
                }
                var sectionTitle = "";
                switch(section.index){
                    case "site_categories":
                        // Can check Hits too...
                        sectionTitle = "Categories";
                        break;
                    case "site_crossreference":
                        sectionTitle = "Fits";
                        break;
                    case "site_products":
                        sectionTitle = "Products";
                        break;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "section-title",
                    children: sectionTitle
                });
            }
        },
        {
            key: "getSectionSuggestions",
            value: function getSectionSuggestions(section) {
                return section.hits;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, hits = _props.hits, onSuggestionSelected = _props.onSuggestionSelected, theme = _props.theme, placeholder = _props.placeholder;
                var value = this.state.value;
                var inputProps = {
                    placeholder: "Enter Search Here",
                    onChange: this.onChange,
                    onKeyDown: this.onKeyDown,
                    value: value
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                    focusInputOnSuggestionClick: false,
                    suggestions: hits,
                    multiSection: true,
                    onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
                    onSuggestionsClearRequested: this.onSuggestionsClearRequested,
                    onSuggestionSelected: onSuggestionSelected,
                    getSuggestionValue: this.getSuggestionValue,
                    renderSuggestion: this.renderSuggestion,
                    inputProps: inputProps,
                    renderSectionTitle: this.renderSectionTitle,
                    getSectionSuggestions: this.getSectionSuggestions,
                    theme: theme
                });
            }
        }
    ]);
    return AutoComplete;
}(react.Component);
(0,_define_property/* default */.Z)(AutoComplete, "propTypes", {
    hits: prop_types_default().arrayOf((prop_types_default()).object).isRequired,
    currentRefinement: (prop_types_default()).string.isRequired,
    refine: (prop_types_default()).func.isRequired,
    onSuggestionSelected: (prop_types_default()).func.isRequired
});
var mapStateToProps = function(state) {
    return {
        search: state.search
    };
};
var mapDispatchToProps = function(dispatch) {
    return {
        setSearchValue: function(payload) {
            return dispatch(search/* setSearchValue */.gI(payload));
        }
    };
};
/* harmony default export */ var Header_AutoComplete = ((0,connectAutoComplete/* default */.Z)((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(AutoComplete)));

;// CONCATENATED MODULE: ./src/components/home/Header/smart-search.jsx

















var searchClient = algoliasearch_lite_umd_default()("CHT94VPAPE", "4126efe6cdbbfb49afcf0d8cd0e8c5a6");
var smart_search_categorySelection, smart_search_categorySelectionInput = null;
var SmartSearch = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SmartSearch, Component);
    var _super = (0,_create_super/* default */.Z)(SmartSearch);
    function SmartSearch(props) {
        (0,_class_call_check/* default */.Z)(this, SmartSearch);
        var _this;
        _this = _super.call(this, props);
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "search", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(smart_search_categorySelectionInput.value != undefined && smart_search_categorySelectionInput.value != "")) return [
                            3,
                            2
                        ];
                        _this1.setState({
                            searching: true
                        });
                        return [
                            4,
                            _this1.props.setSearchValue({
                                query: smart_search_categorySelectionInput.value
                            })
                        ];
                    case 1:
                        _state.sent();
                        router_default().push("/search/[searchterm]", "/search/".concat(encodeURI(smart_search_categorySelectionInput.value.replace(/\s+/g, "-").toLowerCase())));
                        _state.label = 2;
                    case 2:
                        _this1.setState({
                            searching: false
                        });
                        return [
                            2
                        ];
                }
            });
        }));
        _this.state = {
            category: null,
            searching: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(SmartSearch, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                smart_search_categorySelection = document.getElementById("category-selection");
                smart_search_categorySelectionInput = smart_search_categorySelection.querySelectorAll("input")[0];
                smart_search_categorySelectionInput.className += "data-hj-whitelist";
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "smart-search",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mr-1 category-selection",
                            id: "category-selection",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "autosuggest-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InstantSearch/* default */.Z, {
                                    indexName: "site_categories",
                                    searchClient: searchClient,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Configure/* default */.Z, {
                                            hitsPerPage: 6
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_AutoComplete, {
                                            theme: autosuggestTheme,
                                            onSuggestionSelected: function(event, param) {
                                                var suggestion = param.suggestion, suggestionValue = param.suggestionValue;
                                                // Parse URL to correct path, for Client Side Routing...
                                                // TODO: make a function... or put Route into a variable on Search DB...
                                                var urlParse = suggestion.urlSlug.split("/");
                                                var path = "";
                                                switch(urlParse[0]){
                                                    case "product":
                                                        path = "/product/[productid]";
                                                        break;
                                                    case "brand":
                                                        path = "/brand/[brandid]";
                                                        break;
                                                    case "category":
                                                        path = "/category/[categoryid]";
                                                        break;
                                                    default:
                                                        path = "/category/[categoryid]";
                                                }
                                                router_default().push(path, "/".concat(suggestion.urlSlug));
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Index/* default */.Z, {
                                            indexName: "site_categories"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Index/* default */.Z, {
                                            indexName: "site_crossreference"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Index/* default */.Z, {
                                            indexName: "site_products"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PlacesSearch/* default */.Z, {})
                    ]
                });
            }
        }
    ]);
    return SmartSearch;
}(react.Component);
var smart_search_mapStateToProps = function(state) {
    return {
        search: state.search
    };
};
var smart_search_mapDispatchToProps = function(dispatch) {
    return {
        setSearchValue: function(payload) {
            return dispatch(search/* setSearchValue */.gI(payload));
        }
    };
};
/* harmony default export */ var smart_search = ((0,es/* connect */.$j)(smart_search_mapStateToProps, smart_search_mapDispatchToProps)(SmartSearch));
var autosuggestTheme = {
    container: {
        position: "relative"
    },
    input: {
        paddingRight: "10px",
        paddingLeft: "16px",
        lineHeight: "40px",
        height: "40px",
        border: "1px solid #CCC",
        outline: "none",
        font: "inherit"
    },
    inputFocused: {
        outline: "none"
    },
    inputOpen: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
    },
    suggestionsContainer: {
        display: "none"
    },
    suggestionsContainerOpen: {
        display: "block",
        position: "absolute",
        top: 39,
        width: "100%",
        border: "none",
        backgroundColor: "#fff",
        fontFamily: "inherit",
        borderRadius: "3px",
        zIndex: 2,
        boxShadow: "0 1px 10px rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.1)"
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: "none"
    },
    suggestion: {
        cursor: "pointer",
        padding: "10px",
        width: "100%"
    },
    suggestionHighlighted: {
        backgroundColor: "#ddd"
    }
};

;// CONCATENATED MODULE: ./src/components/home/Header/index.jsx











var Header = function(props) {
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), menuOpen = ref1[0], setMenuOpen = ref1[1];
    var openMenu = function() {
        return setMenuOpen(true);
    };
    var isMenuOpen = function(state) {
        setMenuOpen(state.isOpen);
    };
    var cartlist = props.cartlist, isSimplified = props.isSimplified;
    var isAuthenticated = !!((ref = (0,customer/* getCustomer */.jy)()) === null || ref === void 0 ? void 0 : ref.customer);
    var logoDefault = props.masterProvider.isActive ? props.masterProvider.imageUrl : logo_transparent/* default */.Z;
    var phoneNumber = props.masterProvider.isActive ? props.masterProvider.phoneNumber : "1-800-228-8379";
    var linkAs = "";
    var linkHref = "";
    linkAs = router.query.category === "vehicle-batteries-hybrid-electric" ? "/category/vehicle-batteries-hybrid-electric" : "/category/vehicle-batteries-car-or-truck";
    linkHref = router.query.category === "vehicle-batteries-hybrid-electric" ? "/category/[categoryid]?categoryid=vehicle-batteries-hybrid-electric" : "/category/[categoryid]?categoryid=vehicle-batteries-car-or-truck";
    if (isSimplified) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "header-simplified bg-white/70 backdrop-blur-sm",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "inner",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "logo-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (logoDefault === null || logoDefault === void 0 ? void 0 : logoDefault.src) || logoDefault,
                                    className: "",
                                    alt: "Logo"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "menu-items-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PlacesSearch/* default */.Z, {
                                    addressSearch: true,
                                    modalOnly: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "#services",
                                                children: "Our Services"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "#how-it-works",
                                                children: "How it Works"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "highlighted",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: linkHref,
                                                as: linkAs,
                                                children: "Get Started"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "burger-menu-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BurgerMenu.slide, {
                    width: "250px",
                    isOpen: menuOpen,
                    onStateChange: isMenuOpen,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "burger-logo",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                as: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "menu-item",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        objectFit: "contain",
                                        width: "150px",
                                        height: "64px",
                                        src: logoDefault,
                                        alt: "logo"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "burger-navigation-items",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/categories",
                                        as: "/categories",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "menu-item",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-bars"
                                                }),
                                                " All Categories"
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "menu-item",
                                        href: "/add-a-installer",
                                        children: "Become an installer"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header-new",
                id: "header-new",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row align-items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col logo-col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "logo-container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "with-menu-icon",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    "aria-label": "All Categories",
                                                    onClick: function() {
                                                        return openMenu();
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-bars"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "menu-item",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            width: "200px",
                                                            height: "58px",
                                                            src: logoDefault,
                                                            alt: "1800 Battery Logo"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cart",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/cart",
                                                as: "/cart",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fas fa-shopping-cart"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                "(",
                                                                cartlist.filter(function(item) {
                                                                    return item.price;
                                                                }).length,
                                                                ")"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "contenful",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "smart-search-container",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(smart_search, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                            className: "navigation desktop user-related-container",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: "site-related",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/categories",
                                                            as: "/categories",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                className: "menu-item",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fas fa-bars"
                                                                    }),
                                                                    " All Categories"
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "user-related temp",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/locations",
                                                                as: "/locations",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fas fa-map-marked-alt"
                                                                        }),
                                                                        " Locations"
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "".concat(isAuthenticated ? "/dashboard" : "/login"),
                                                                    as: "".concat(isAuthenticated ? "/dashboard" : "/login"),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                className: "fas fa-user"
                                                                            }),
                                                                            " Account"
                                                                        ]
                                                                    })
                                                                }),
                                                                isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                    className: "dropdown",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/dashboard",
                                                                                as: "/dashboard",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                            className: "fas fa-user-cog"
                                                                                        }),
                                                                                        " Dashboard"
                                                                                    ]
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            className: "logout",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/logout",
                                                                                as: "/logout",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                            className: "fas fa-sign-out-alt"
                                                                                        }),
                                                                                        " Logout"
                                                                                    ]
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                !isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                    className: "dropdown",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/login",
                                                                                as: "/login",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                            className: "fas fa-sign-in-alt"
                                                                                        }),
                                                                                        " Login"
                                                                                    ]
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/register",
                                                                                as: "/register",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                            className: "fas fa-user-plus"
                                                                                        }),
                                                                                        " Register"
                                                                                    ]
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            className: "cart",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                className: "!text-[.9rem]",
                                                                href: "/cart",
                                                                as: "/cart",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fas fa-shopping-cart"
                                                                        }),
                                                                        " ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            children: [
                                                                                "(",
                                                                                cartlist.filter(function(item) {
                                                                                    return item.price;
                                                                                }).length,
                                                                                ")"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col far-right",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "need-help-new",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "Need help? Call us at",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        style: {
                                                            color: "inherit"
                                                        },
                                                        href: "tel:".concat(phoneNumber.split("-").join("")),
                                                        children: phoneNumber
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                        className: "navigation",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "user-related",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/locations",
                                                        as: "/locations",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fas fa-map-marked-alt"
                                                                }),
                                                                " Locations"
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "".concat(isAuthenticated ? "/dashboard" : "/login"),
                                                            as: "".concat(isAuthenticated ? "/dashboard" : "/login"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fas fa-user"
                                                                    }),
                                                                    " Account"
                                                                ]
                                                            })
                                                        }),
                                                        isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            className: "dropdown",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/dashboard",
                                                                        as: "/dashboard",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "fas fa-user-cog"
                                                                                }),
                                                                                " Dashboard"
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    className: "logout",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/logout",
                                                                        as: "/logout",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "fas fa-sign-out-alt"
                                                                                }),
                                                                                " Logout"
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        !isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            className: "dropdown",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/login",
                                                                        as: "/login",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "fas fa-sign-in-alt"
                                                                                }),
                                                                                " Login"
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/register",
                                                                        as: "/register",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "fas fa-user-plus"
                                                                                }),
                                                                                " Register"
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "cart",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/cart",
                                                        as: "/cart",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fas fa-shopping-cart"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    children: [
                                                                        "(",
                                                                        cartlist.filter(function(item) {
                                                                            return item.price;
                                                                        }).length,
                                                                        ")"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var Header_mapStateToProps = function(state) {
    return {
        cartlist: state.cartlist.cart
    };
};
/* harmony default export */ var home_Header = ((0,es/* connect */.$j)(Header_mapStateToProps)(Header));


/***/ })

}]);